// src/components/ChartSkeleton.jsx
import React from 'react';
import { Card, CardHeader, CardContent, Skeleton } from '@mui/material';

export default function ChartSkeleton({ height = 480 }) {
    return (
        <Card
            sx={{ borderRadius: 3, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}
        >
            <CardHeader
                title={<Skeleton variant="text" width="40%" />}
                action={<Skeleton variant="circular" width={24} height={24} />}
                sx={{ paddingBottom: 1 }}
            />
            <CardContent sx={{ height }}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
            </CardContent>
        </Card>
    );
}
